import { EKwikUIImageLoadingType, EKwikUIImageType } from "./image.definitions";

export const DEFAULT_VALUES = {
  altText: "Image",
  class: "",
  html: { before: "", after: "" },
  id: "",
  imageSrc: "",
  imageType: EKwikUIImageType.URL,
  loadingType: EKwikUIImageLoadingType.AUTO,
  styles: ""
};

export const VALIDATE_KEY_VALUES = {
  altText: true,
  class: true,
  id: true,
  imageSrc: true,
  imageType: true,
  loadingType: true,
  styles: true
};
